import React from 'react';
import PropTypes from 'prop-types';
import styles from './foxbit-upload-modal.css';

const FoxbitUploadModalComponent = ({
    onClose,
    onCompile,
    onUpload,
    isConnected,
    compileResult,
    uploadStatus,
    blockSummary
}) => {
    const commands = compileResult?.commands || [];
    const errors = compileResult?.errors || [];
    const warnings = compileResult?.warnings || [];

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h2>🦊 FoxBit 업로드</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>

                {/* Body */}
                <div className={styles.modalBody}>
                    {/* 컴파일 결과만 표시 */}
               <div className={`${styles.panel} ${styles.panelRight}`}>
                  <h3>💻 컴파일 결과</h3>
               <div className={styles.commandList}>
                 {commands.length > 0 ? (
                     commands.map((cmd, index) => (
                          <div key={index} className={styles.commandLine}>
                          <span className={styles.lineNumber}>
                            {String(index).padStart(2, '0')}
                          </span>
                         {cmd}
                      </div>
                     ))
                 ) : (
                     <div style={{color: '#666'}}>
                         컴파일 결과가 여기에 표시됩니다
                     </div>
                   )}
                </div>
        
        {errors.length > 0 && (
             <div className={styles.errorMessage}>
             ❌ 지원되지 않는 블록:
             {errors.map((e, i) => (
             <div key={i}>• {e.opcode} - {e.message}</div>
                ))}
             </div>
        )}
        
        {warnings.length > 0 && (
            <div className={styles.warningMessage}>
             ⚠️ 경고:
            {warnings.map((w, i) => (
                 <div key={i}>• {w.message}</div>
             ))}
           </div>
          )}
       </div>
</div>

                <div className={styles.modalFooter}>
                    <div className={styles.status}>
                        <span className={`${styles.statusDot} ${isConnected ? styles.connected : styles.disconnected}`} />
                        <span>{isConnected ? '연결됨' : '연결 안됨'}</span>
                        {uploadStatus && <span>| {uploadStatus}</span>}
                    </div>                    
                    <div className={styles.buttonGroup}>
                        <button className={`${styles.btn} ${styles.btnCompile}`} onClick={onCompile}>
                            컴파일
                        </button>
                        <button 
                            className={`${styles.btn} ${styles.btnUpload}`} 
                            onClick={onUpload}
                            disabled={!isConnected || commands.length === 0 || errors.length > 0}
                        >
                            업로드
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

FoxbitUploadModalComponent.propTypes = {
    onClose: PropTypes.func.isRequired,
    onCompile: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    isConnected: PropTypes.bool,
    compileResult: PropTypes.object,
    uploadStatus: PropTypes.string,
    blockSummary: PropTypes.string
};

FoxbitUploadModalComponent.defaultProps = {
    isConnected: false,
    compileResult: null,
    uploadStatus: '',
    blockSummary: ''
};

export default FoxbitUploadModalComponent;